import { render, staticRenderFns } from "./HeatmapsPages.vue?vue&type=template&id=6a9c10fa&scoped=true&"
import script from "./HeatmapsPages.vue?vue&type=script&lang=js&"
export * from "./HeatmapsPages.vue?vue&type=script&lang=js&"
import style0 from "./HeatmapsPages.vue?vue&type=style&index=0&id=6a9c10fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9c10fa",
  null
  
)

export default component.exports